<template>
  <va-input v-bind="$props" class="va-rich-text-input">
    <vue-editor v-model="input" :editor-toolbar="customToolbar" @change="change" @input="updateText"></vue-editor>
  </va-input>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import { VueEditor } from 'vue2-editor';

export default {
  components: { VueEditor },
  mixins: [Input],
  props: {
    /**
     * HTML text to be edited.
     * @model
     */
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3] }],
        ['bold', 'italic', 'underline', 'link'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['clean'],
      ],
    };
  },
  methods: {
    updateText(value) {
      this.update(value);
    },
  },
};
</script>

<style>
.va-rich-text-input .v-input__slot {
  display: block;
}
.va-rich-text-input .v-label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
</style>
